import loadable from '@loadable/component';
import { LoaderSpin } from 'client/ui/loader/LoaderSpin';
import React from 'react';

/**
 * Lazy loading dei comuni ANPR
 */
export const PDNDMunicipalityLoadableInput = loadable(
  () =>
    import(
      /* webpackChunkName: "anpr_municipality" */ './PDNDMunicipalityInput'
    ),
  { fallback: <LoaderSpin full /> }
);
